import { CURRENCIES, DEFAULT_CATS } from '@/constants';
export const uid = () => crypto.randomUUID();
export const toStr = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
export const todayStr = () => toStr(new Date());
export const fmt = (amt, cur) => {
    const c = CURRENCIES.find(x => x.code === cur) || { sym: cur };
    const abs = Math.abs(amt);
    const s = abs % 1 === 0
        ? abs.toLocaleString('ru-RU', { maximumFractionDigits: 0 })
        : abs.toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    const neg = amt < 0 ? '−' : '';
    return ['USD', 'EUR', 'GBP'].includes(cur) ? `${neg}${c.sym}${s}` : `${neg}${s} ${c.sym}`;
};
export const fmtParts = (amt, cur) => {
    const c = CURRENCIES.find(x => x.code === cur) || { sym: cur };
    const abs = Math.abs(amt);
    const neg = amt < 0 ? '−' : '';
    const prefixSym = ['USD', 'EUR', 'GBP'].includes(cur);
    const intStr = Math.floor(abs).toLocaleString('ru-RU');
    const frac = abs % 1 === 0 ? null : (abs - Math.floor(abs)).toFixed(2).slice(1); // ".50"
    return {
        prefix: prefixSym ? `${neg}${c.sym}` : neg,
        integer: intStr,
        decimal: frac,
        suffix: prefixSym ? '' : ` ${c.sym}`,
    };
};
export const getCalCells = (year, month, ws, showNextMonth) => {
    const first = new Date(year, month, 1).getDay();
    const days = new Date(year, month + 1, 0).getDate();
    const offset = (first - ws + 7) % 7;
    const prevMonthDays = new Date(year, month, 0).getDate();
    const cells = [];
    for (let i = offset; i > 0; i--)
        cells.push(new Date(year, month - 1, prevMonthDays - i + 1));
    for (let d = 1; d <= days; d++)
        cells.push(new Date(year, month, d));
    if (showNextMonth) {
        const nextDays = new Date(year, month + 2, 0).getDate();
        for (let d = 1; d <= nextDays; d++)
            cells.push(new Date(year, month + 1, d));
    }
    else {
        let d = 1;
        while (cells.length % 7 !== 0)
            cells.push(new Date(year, month + 1, d++));
    }
    return cells;
};
export const effAmt = (tx) => tx.actual !== null && tx.actual !== undefined ? tx.actual : tx.planned;
/** Является ли транзакция приходной для баланса (income или возврат из накоплений) */
export const isInflow = (tx) => tx.type === 'income' || !!tx.fromSavings;
export const monthEndStr = (y, m) => `${y}-${String(m + 1).padStart(2, '0')}-${String(new Date(y, m + 1, 0).getDate()).padStart(2, '0')}`;
export const yearEndStr = (y) => `${y}-12-31`;
export const getBudgetCats = (b) => b.categories || DEFAULT_CATS;
export const catById = (b, id) => getBudgetCats(b).find(c => c.id === id);
export const computeBalances = (budget, year, month) => {
    const pfx = `${year}-${String(month + 1).padStart(2, '0')}-`;
    const days = new Date(year, month + 1, 0).getDate();
    let opening = 0;
    budget.transactions.forEach(tx => {
        if (tx.date < pfx + '01') {
            const e = effAmt(tx);
            if (e != null)
                opening += isInflow(tx) ? e : -e;
        }
    });
    const bal = {};
    let run = opening;
    for (let d = 1; d <= days; d++) {
        const ds = pfx + String(d).padStart(2, '0');
        budget.transactions.filter(tx => tx.date === ds).forEach(tx => {
            const e = effAmt(tx);
            if (e != null)
                run += isInflow(tx) ? e : -e;
        });
        bal[ds] = run;
    }
    return bal;
};
export const computeSummary = (budget, periodEnd) => {
    const today = todayStr();
    let actual = 0, forecast = 0;
    budget.transactions.forEach(tx => {
        if (tx.date <= today && tx.actual != null)
            actual += isInflow(tx) ? tx.actual : -tx.actual;
        if (tx.date <= periodEnd) {
            const e = effAmt(tx);
            if (e != null)
                forecast += isInflow(tx) ? e : -e;
        }
    });
    const ts = toStr(new Date(Date.now() + 86400000));
    let free = actual;
    budget.transactions.forEach(tx => {
        if (tx.date >= ts && tx.date <= periodEnd && (tx.actual === null || tx.actual === undefined) && tx.planned != null)
            free += isInflow(tx) ? tx.planned : -tx.planned;
    });
    return { actual, forecast, free };
};
